// const url = 'http://192.168.1.183:8088'; // 晨 阳   
const url = 'https://crmapi.magaoedu.com'; //正式服务器
import axios from 'axios'
import { Message } from 'element-ui';
import $todo from '@/utils/common';
import store from '@/store/index';
// 添加请求拦截器
const service = axios.create({
    baseURL: url, 
    // timeout: 8000,
    // withCredentials: true
});
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // 一般是添加token再发送
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 如果业务逻辑错误
    if(response.data.status=='4098'){
        $todo.removeCookie('token');
        store.commit('updateToken', false);
        Message.error({ message: '登录失效，请重新登录' });
    }
    if (response.status || response.status === 200) {
        // 如果返回数据中code=500,或者是未登录401,权限错误403
        if (response.data.code === 500 || response.data.code === 401 || response.data.code === 403) {
            Message.error({ message: response.data.message });
            return;
        }
        // 如果是其他
        if (response.data.message) {
            Message.success({ message: response.data.message });
        }
    }
    return response.data;
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    if (error.response) {
        if (error.response.data.code === 504 || error.response.data.code === 404) {
            Message.error({ message: '服务器出错了' });
        } else if (error.response.data.code === 403) {
            Message.error({ message: '权限不足，请联系管理员' });
        } else if (error.response.data.code === 401) {
            Message.error({ message: '尚未登录，请登录！' });
        } else {
            if (error.response.data.message) {
                Message.error({ message: error.response.data.message });
            } 
        }
    }else{
        Message.error({ message: '网络连接失败，查看电脑网络是否可用' });
        $todo.removeCookie('token');
        store.commit('updateToken', false);
    }
    return;
});
export default service;
